import clsx from 'clsx';
import React from 'react';
import { BodyTextSmall } from '../Type';
import { bool, number } from 'prop-types';
import './CharacterCount.less';
export default function CharacterCount(props) {
    const { actualLength, maxLength, isTooLong, isNearlyTooLong, disabled, hideCharacterCount } = props;
    if (maxLength && !hideCharacterCount) {
        return (React.createElement(BodyTextSmall, { name: 'character-counter', className: clsx('kal-text-length', isTooLong && !disabled && 'too-long', isNearlyTooLong && !disabled && 'nearly-too-long'), bold: isTooLong || isNearlyTooLong, fade: disabled, noTopSpacer: true },
            actualLength,
            "/",
            maxLength));
    }
    return false;
}
CharacterCount.propTypes = {
    actualLength: number,
    maxLength: number,
    isTooLong: bool,
    isNearlyTooLong: bool,
    disabled: bool,
    hideCharacterCount: bool,
};
//# sourceMappingURL=CharacterCount.js.map